import React from "react";
import DataQuery from "data/DataQuery";
import { Users_GetSimplified } from "data/endpoints";
import { useQuery } from "data/hooks/useQuery";
import CardLink from "features/shared/components/buttons/CardLink";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import Pagination from "features/shared/components/pagination/Pagination";
import UserDto from "../dtos/UserDto";
import axios from "axios";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { AdminUserAction, setAdminUser } from "infrastructure/store/adminUser/AdminUserActions";
import DataGridHeader from "features/shared/components/dataGrid/DataGridHeader";
import PagedDataResultDTO from "features/shared/dtos/PagedDataResultDTO";
import { useStateDataGrid } from "features/shared/components/dataGrid/hooks/useStateDataGrid";
import DataFilterModal from "features/shared/components/dataFilterModal/DataFilterModal";
import { loadDataFilterConfig } from "features/shared/helpers/modules";
import { useTranslation } from "react-i18next";

const usersDataFilterJson = loadDataFilterConfig("usersDataFilter");

const pageSize = 24;

interface Props {}

const UserSelectSection = (props: Props) => {
  //#endregion translations
  const tLabels = useTranslation("admin\\administration").t;
  //#endregion

  //#region router
  const history = useHistory();
  //#endregion

  //#region store
  const adminUserDispatch = useDispatch<Dispatch<AdminUserAction>>();
  //#endregion store

  //#region data grid hook
  const {
    dataGrid,
    descriptors,
    setDescriptors,
    showFilter,
    setShowFilter,
    paginationPageChangeHandler,
    filterApplyHandler,
    filterResetHandler,
    isApplyFilter,
    conditionalRefresh
  } = useStateDataGrid(pageSize, usersDataFilterJson);
  //#endregion data grid hook

  //#region fetch data
  const query: DataQuery = {
    url: Users_GetSimplified,
    params: new URLSearchParams(dataGrid.computedUrlSearchParams)
  }
  const {data: users, loadStatus: usersStatus} = useQuery<PagedDataResultDTO<UserDto>>(query, { count: 0, result: [] }, [dataGrid.computedUrlSearchParams], { useTracker: true }, conditionalRefresh);
  //#endregion fetch data

  //#region handlers
  const selectUserHandler = (user: UserDto) => {
    axios.defaults.headers.common["email"] = user.email;
    adminUserDispatch(setAdminUser({
      isSelectedUser: true,
      email: user.email
    }));
    history.push("/");
  }
  //#endregion handlers

  //#region sub-renders
  const renderUsers = () => {
    return users.result.map((item) =>
      <div className="col-sm-6 col-lg-4 col-xl-3 px-2" key={item.id}>
        <CardLink 
          title={item.email}
          icon="user"
          onClick={() => selectUserHandler(item)}
        />
      </div>
    );  
  } 
  //#endregion sub-renders

  //#region render
  return (
    <NoContentWrapper
      data={users}
      loadStatus={usersStatus}
      noContentAsAlert
      isActiveFilter={isApplyFilter}
    >
      <DataGridHeader 
        count={users.count}
        setShowFilterModal={setShowFilter}
        filterActive={isApplyFilter()}
      />
      <NoContentWrapper
        data={users}
        loadStatus="AfterFirstLoad"
        noContentAsAlert
        noContentInfo={tLabels("userSelectSection.noUsersFound")}
        isEmpty={() => users.count === 0}
      >
        <div className="row no-gutters mx-n2">
          {renderUsers()}
        </div>
        <div className="d-flex justify-content-center mt-4">
          <Pagination
            urlParams={new URLSearchParams(dataGrid.computedUrlSearchParams)}
            count={users.count!}
            pageSize={pageSize}
            onPageChange={paginationPageChangeHandler}
          />
        </div>
      </NoContentWrapper>
      <DataFilterModal
        descriptors={descriptors}
        setDescriptors={setDescriptors}
        applyButtonOnClick={filterApplyHandler}
        resetButtonOnClick={filterResetHandler}
        show={showFilter}
        setShow={setShowFilter}
      />
    </NoContentWrapper>
  );
  //#endregion render
};

export default UserSelectSection;
